import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CancelIcon from '@mui/icons-material/Cancel';

/**
 * Optional-note dialog for owner / GM / accountant dismissing a pending job unlock request.
 */
const DismissJobUnlockRequestDialog = ({
  open,
  reason,
  onReasonChange,
  onClose,
  onConfirm,
  loading = false,
  workOrder = null,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (loading) return;
      onClose?.();
    }}
    aria-labelledby="dismiss-unlock-request-dialog-title"
    maxWidth="sm"
    fullWidth
  >
    <DialogTitle id="dismiss-unlock-request-dialog-title">
      Dismiss Unlock Request
    </DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        This clears the unlock request{workOrder ? ` for work order ${workOrder}` : ''}.
        The job stays locked. The requester will be notified
        {reason?.trim() ? ' with your note' : ''}.
      </DialogContentText>
      <TextField
        autoFocus
        fullWidth
        multiline
        minRows={3}
        maxRows={6}
        label="Note (optional)"
        inputProps={{ maxLength: 500 }}
        value={reason}
        onChange={(e) => onReasonChange?.(e.target.value)}
        disabled={loading}
        placeholder="Why is this unlock request being dismissed?"
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        color="warning"
        variant="contained"
        disabled={loading}
        startIcon={<CancelIcon />}
      >
        {loading ? 'Dismissing…' : 'Dismiss Request'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DismissJobUnlockRequestDialog;
